import { Button } from "@access-selfcare/shared-libs";
import { useAtomValue } from "jotai";
import * as React from "react";
import { searchTermAtom } from "src/components/Event/Dashboard/utils/filtersAtom";
import { Highlight } from "@sgbs-ui/core";
import { isDateBeforeToday } from "src/utils/dateUtils";
import { EventDateDisplay } from "src/v2/Components/EventDateDisplay";

type EventCardProps = {
  startDate: Date;
  endDate: Date;
  category: string;
  title: string;
  location: string;
  onDetailsClick?: () => void;
};

export const EventCard: React.FC<EventCardProps> = ({
  startDate,
  endDate,
  category,
  title,
  location,
  onDetailsClick,
}) => {
  const searchTerm = useAtomValue(searchTermAtom);

  return (
    <div
      className={`border rounded-md shadow-sm ps-3 pb-4 pe-4 pt-4 bg-white d-flex flex-column ${
        isDateBeforeToday(endDate) ? "opacity-50" : ""
      }`}
      style={{ minHeight: "290px", maxWidth: 400, width: "100%" }}
    >
      <EventDateDisplay startDate={startDate} endDate={endDate} />
      <div className="mt-2 ms-0 ms-md-2 text-secondary">{category}</div>
      <h5 className="mt-1 ms-0 ms-md-2 font-semibold text-sm" style={{ overflowWrap: "break-word" }} title={title}>
        <Highlight term={[searchTerm]} text={title} color="info" />
      </h5>
      <div className="mt-4 d-flex flex-column flex-md-row justify-content-between mt-auto gap-2 gap-md-0">
        <div className="col-12 col-md-6">
          {location && (
            <div className="d-flex text-secondary ">
              <i className="icon icon-md">location_on</i>
              <span className="mt-2 text-truncate" title={location}>
                {location}
              </span>
            </div>
          )}
        </div>
        <div className="col-12 col-md-6 d-flex align-items-end">
          <Button onClick={onDetailsClick} className="w-100 mt-2 mt-md-0" btnType="default" color="secondary">
            See details
          </Button>
        </div>
      </div>
    </div>
  );
};
